import {
	CONFIRMATION_AGENDAS, CONFIRMATION_ITEMS_AGENDA, CUSTOM_ABSTENTION_AGENDAS, CUSTOM_AGENDAS,
	DEFAULT_ITEMS_AGENDA, INFORMATIVE_AGENDAS, VOTE_VALUES
} from '../../utils/constants';
import CheckboxInput from '../inputs/CheckboxInput';
import RadioButtonInput from '../inputs/RadioButtonInput';

/*
* Element that dinamically produces the diferen agendas
*/
function AgendaFactory({
	agenda,
	value,
	onChange,
	colors,
	translate,
	classNameDIV = 'flex flex-col space-y-6 w-full',
	classNameLABEL = 'text-black',
}) {
	/* Formats items from server structure to value, text, label structure */
	const formatCustomItems = items => [...items.map(item => ({ value: item.id, text: '', label: item.value })), CUSTOM_ABSTENTION_AGENDAS];

	/* Informative agendas only display the agenda.agendaSubject */
	if (agenda.subjectType === INFORMATIVE_AGENDAS) {
		return <div className={classNameDIV}>
			<label className={classNameLABEL}>{agenda.agendaSubject}</label>
		</div>;
	}

	/* Custom agendas display the agenda.items as possible answers and can have simple or multiple answer */
	if (CUSTOM_AGENDAS.includes(agenda.subjectType)) {
		/* We need to format the options for the inputs */
		const items = formatCustomItems(agenda.items);

		/* Only one answer */
		if (agenda.options.maxSelections === 1) {
			return <div className={classNameDIV}>
				<label className={classNameLABEL}>{agenda.agendaSubject}</label>
				<RadioButtonInput
					name={agenda.id}
					items={items}
					value={value}
					onChange={onChange}
					colors={colors}
					isVote={true}
					required={true}
					translate={translate}
				/>
			</div>;
		}

		/* Multiple answers */
		return <div className={classNameDIV}>
			<label className={classNameLABEL}>{agenda.agendaSubject}</label>
			<CheckboxInput
				name={agenda.id}
				items={items}
				value={value}
				onChange={onChange}
				maxSelections={agenda.options.maxSelections}
				minSelections={agenda.options.minSelections}
				uniqueValues={[VOTE_VALUES.ABSTENTION]}
				colors={colors}
				isVote={true}
				required={true}
				translate={translate}
			/>
		</div>;
	}

	/* Confirmation agendas have only Yes or NO answers with a RadioButton */
	if (agenda.subjectType === CONFIRMATION_AGENDAS) {
		return <div className={classNameDIV}>
			<label className={classNameLABEL}>{agenda.agendaSubject}</label>
			<RadioButtonInput
				name={agenda.id}
				items={CONFIRMATION_ITEMS_AGENDA}
				value={value}
				onChange={onChange}
				colors={colors}
				isVote={true}
				required={true}
				translate={translate}
			/>
		</div>;
	}

	/* Default agendas have Yes, No and Abstention as possible answers and are always a Radio Button */
	/* If it doesnt fit any other type it will be displayed as a default */
	return <div className={classNameDIV}>
		<label className={classNameLABEL}>{agenda.agendaSubject}</label>
		<RadioButtonInput
			name={agenda.id}
			items={DEFAULT_ITEMS_AGENDA}
			value={value}
			onChange={onChange}
			colors={colors}
			isVote={true}
			required={true}
			translate={translate}
		/>
	</div>;
}

export default AgendaFactory;
